// extracted by mini-css-extract-plugin
export default {"closeBtn":"closeBtn__r1+ox","svg":"svg__Hn3dP"};